import React from 'react'
import { Form, Row } from 'react-bootstrap'
import GRADE_LEVELS from '../../../constants/grade-levels'
import { uniq } from 'lodash'
import useViewport from '../../../hooks/use-viewport'

const GradeLevelsEditor = ({
    value = [],
    onChange = () => {}
}) => {

    const { breakpoint, breakpoints } = useViewport()

    const addGrade = React.useCallback(grade => {
        onChange(uniq([...value, grade]))
    }, [value, onChange])

    const removeGrade = React.useCallback(grade => {
        onChange(value.filter( v => v !== grade))
    }, [value, onChange])

    const clearGrades = React.useCallback(() => {
        onChange([])
    }, [value, onChange])

    const addAllGrades = React.useCallback(() => {
        onChange(Object.values(GRADE_LEVELS))
    }, [value, onChange])

    const hasAllGrades = value.length === Object.keys(GRADE_LEVELS).length
    const label = breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'CERTAIN GRADES ONLY' : 'ONLY GRADES'

    const renderGradeCheck = (gradeLevel, label) => {
        const hasGrade = value.includes(gradeLevel)
        return (
            <div>
                <Form.Check inline type='checkbox' label={label} checked={hasGrade} onChange={e => e.target.checked ? addGrade(gradeLevel) : removeGrade(gradeLevel)}/>
            </div>
        )
    }

    const renderGrades = () => {
        if (hasAllGrades) {
            return null
        }
        return (
            <div style={{ paddingLeft: '20px'}}>
                {renderGradeCheck(GRADE_LEVELS.SENIOR, 'SENIORS')}
                {renderGradeCheck(GRADE_LEVELS.JUNIOR, 'JUNIORS')}
                {renderGradeCheck(GRADE_LEVELS.SOPHOMORE, 'SOPHOMORES')}
                {renderGradeCheck(GRADE_LEVELS.FRESHMAN, 'FRESHMEN')}
            </div>   
        )
    }

    return (
        <React.Fragment>
            <div>
                <div>
                    <Form.Check
                        inline
                        type='checkbox'
                        label={label}
                        checked={!hasAllGrades}
                        onChange={e => e.target.checked ? clearGrades() : addAllGrades()}
                    />
                </div>
                {renderGrades()}
            </div>
            
        </React.Fragment>
    )
}

export default GradeLevelsEditor